import { render, staticRenderFns } from "./ListPanelItem.vue?vue&type=template&id=18f2a70b&scoped=true&"
import script from "./ListPanelItem.vue?vue&type=script&lang=js&"
export * from "./ListPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./ListPanelItem.vue?vue&type=style&index=0&id=18f2a70b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2a70b",
  null
  
)

export default component.exports